module.exports = __webpack_public_path__ + "images/the-house-df3c6c5262f59118b78c2db3af036b0c.png";